"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mainLogger = exports.logWarning = exports.logDebug = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _logger = require("@ori/logger");
var _constants = require("./constants");
const mainLogger = exports.mainLogger = new _logger.Logger(_constants.PACKAGE_NAME, {
  teamName: _constants.TEAM_NAME
});
const logDebug = exports.logDebug = (0, _checkoutUtils.getDebugLogger)(_constants.APP_NAME, _constants.LOG_COLOR);
const logWarning = exports.logWarning = (0, _checkoutUtils.getWarningLogger)(_constants.APP_NAME, _constants.LOG_COLOR);